exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".close-icon[data-v-7492a40b]{font-size:30px}", "", {"version":3,"sources":["/home/webuser/miles/releases/83/spa/src/pages/courses/course/Course.scss"],"names":[],"mappings":"AAIA,6BACE,cAAA,CAAA","file":"Course.scss?vue&type=style&index=0&id=7492a40b&prod&lang=scss&scoped=true&","sourcesContent":[".course {\n\n}\n\n.close-icon {\n  font-size: 30px;\n}\n"],"sourceRoot":""}]);

// exports
